import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconNavManualOrders24pxRegular = function IconNavManualOrders24pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 2c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.797 7.741a1 1 0 011.225-.707l2.732.732a1 1 0 01.241 1.832L8.5 13.348a1 1 0 11-1-1.732l4.404-2.543-.4-.107a1 1 0 01-.707-1.225z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.198 16.071a1 1 0 01-1.225.707l-2.732-.732A1 1 0 019 14.214l6.495-3.75a1 1 0 011 1.732l-4.404 2.543.4.107a1 1 0 01.707 1.225z"
    })]
  }));
};
export default IconNavManualOrders24pxRegular;